import React, { useEffect, useState } from "react";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import "../../node_modules/react-vis/dist/style.css";
import "../css/home.css";
import Constants from "../util/Constants";

export default function CompanyRecommendations(props) {
  const initialRecommendations = {
    buy: 0,
    strongBuy: 0,
    hold: 0,
    sell: 0,
    strongSell: 0,
  };

  const [recommendations, setRecommendations] = useState(
    initialRecommendations
  );

  useEffect(() => {
    let url = Constants.RECOMMENDATIONS_URL + "&symbol=" + props.symbol;

    fetch(url)
      .then((response) => response.json())
      .then((recommendationsData) => {
        if (recommendationsData.length > 0)
          setRecommendations(recommendationsData[0]);
      })
      .catch(function (error) {
        console.log(
          "CompanyRecommendations:stock app response Error:",
          error.stack
        );
      });

    return () => {};
  }, [props]);

  const data = [
    {
      name: "Buy",
      value: recommendations.strongBuy + recommendations.buy,
    },
    { name: "Hold", value: recommendations.hold },
    {
      name: "Sell",
      value: recommendations.sell + recommendations.strongSell,
    },
  ];

  const COLORS = ["#2E7D32", "#7B1FA2", "#C62828"];
  const LEGEND_COLORS = ["#2E7D32", "#9C27B0", "#C62828"];

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "100%",
          flex: "1 1 0",
          minHeight: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <PieChart margin={{ top: 2, right: 4, bottom: 0, left: 4 }}>
            <defs>
              {COLORS.map((color, index) => (
                <linearGradient key={index} id={`rec-color-${index}-${props.symbol}`}>
                  <stop offset="0%" stopColor={color} />
                  <stop offset="100%" stopColor={color} />
                </linearGradient>
              ))}
            </defs>
            <Pie
              data={data}
              cx="50%"
              cy="72%"
              startAngle={180}
              endAngle={0}
              innerRadius="48%"
              outerRadius="95%"
              fill="#8884d8"
              paddingAngle={4}
              dataKey="value"
              animationBegin={0}
              animationDuration={1500}
              animationEasing="ease-out"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={`url(#rec-color-${index}-${props.symbol})`}
                  stroke="#fff"
                  strokeWidth={2}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "8px 12px",
          marginTop: "4px",
          fontSize: "11px",
          fontWeight: "600",
          color: "#34495e",
        }}
      >
        {data.map((entry, index) => (
          <span key={entry.name} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <span
              style={{
                width: 8,
                height: 8,
                borderRadius: 2,
                backgroundColor: LEGEND_COLORS[index],
              }}
            />
            {entry.name} ({entry.value})
          </span>
        ))}
      </div>
    </div>
  );
}
